import { Component, Prop, Vue } from "vue-property-decorator";
import ModalBase from "@/components/modalBase/modalBase";

@Component({
  components: {
    ModalBase,
  },
})
export default class Alert extends Vue {
  @Prop({ default: false }) show!: Boolean;
  @Prop({ default: "" }) title!: String;
  @Prop({ default: "" }) message!: String;
  @Prop({ default: "Aceptar" }) option1Text!: String;
  @Prop({ default: "Cancelar" }) option2Text!: String;
  @Prop({ default: "xsmall" }) size!: String;

  // Alert types: info, warning, error
  @Prop({ default: null }) alertType: string;

  get getAlertIconSrc() {
    switch (this.alertType) {
      case "info":
        return "/icons/info-gray.svg";
      case "warning":
        return "/icons/warning-yellow.svg";
      case "error":
        return "/icons/warning-red.svg";
      default:
        return "";
    }
  }

  _option1() {
    this.$emit("on-main-option");
  }

  _option2() {
    this.$emit("on-secondary-option");
  }

  _close() {
    this.$emit("close-alert");
  }
}
